import { Box } from '@mui/material';
import { AlertBoxMsg } from '@qrios/frontend-library';

import WithFormLayout from '../../../../../../../../common/with-form-layout';

import { useNewSecretsRequest } from '../hooks/useNewSecretsRequest';

interface Props {
  onSubmit: (ussdShortcode?: string, userMsisdn?: string) => void;
  onClose: () => void;
}

const InfoStep = ({ onSubmit, onClose }: Props) => {
  const { newSecretsRequestError, newSecretsRequestLoading, handleRecreateSecretsRequest } = useNewSecretsRequest();

  return (
    <WithFormLayout
      submitLabel="Go to OTP verification"
      secondaryLabel="Close without update"
      onSubmit={() => {
        handleRecreateSecretsRequest(onSubmit);
      }}
      onSecondary={onClose}
      loading={newSecretsRequestLoading}
    >
      <Box mb={2}>
        <AlertBoxMsg severity="warning">
          <Box>
            <Box style={{ marginBottom: '16px' }}>You won&apos;t be able to use your previous secrets!</Box>
            <Box>
              New client ID and secret will be generated, and previous ones cannot be used. Verification is required to
              prevent unauthorized changes. You&apos;ll receive an OTP on your phone, so ensure device access for the
              next step.
            </Box>
          </Box>
        </AlertBoxMsg>
      </Box>
      {newSecretsRequestError ? (
        <Box pt={1}>
          <AlertBoxMsg severity={newSecretsRequestError.severity}>{newSecretsRequestError.message}</AlertBoxMsg>
        </Box>
      ) : null}
    </WithFormLayout>
  );
};

export default InfoStep;
